import React, { useEffect, useState } from 'react'

import { Box, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { OpeningHours, OpeningHoursDay } from '@3m5/sm_publish-frontend-api'
import OpeningHoursInput from './OpeningHoursInput'

type Props = {
  openingHours: OpeningHours | undefined
  setOpeningHours: (data: OpeningHoursDay[]) => void
}

const OpeningHoursDays: React.FC<Props> = ({ openingHours, setOpeningHours }) => {
  const { t } = useTranslation()
  const [days, setDays] = useState<OpeningHoursDay[]>([])

  const handleInputChange = (val: string, index: number, currentDay: OpeningHoursDay, point: string) => {
    setDays(days => {
      return days.map(day => {
        if (day.dayType !== currentDay.dayType) return day
        return {
          ...day,
          hours: day.hours.map((item, i) => {
            return i === index ? { ...item, [point]: val } : item
          }),
        }
      })
    })
  }

  useEffect(() => {
    openingHours && openingHours.days.map(day => { // set empty inputs on day.hours.length === 0
      day.hours.length === 0
        ? setDays(days => [...days, { ...day, hours: [{ start: '', end: '' }] }])
        : setDays(days => [...days, day])
    })
  }, [openingHours])

  useEffect(() => {
    const correctData = days.map(day => { // set to empty hour arrays, on days, where start or end hour aren't added
      return {
        ...day,
        hours: day.hours.filter(item => item.end !== '' || item.start !== ''),
      }
    })
    setOpeningHours && setOpeningHours(correctData)
  }, [days])

  return (
    <>
      {days && days.map((day, index) => {
        return (
          <Box key={index} sx={{ pt: 1 }}>
            <Typography sx={{ mt: 1 }} variant='h5'>{t(`facebookSettingsCommon:${day.dayType.toLowerCase()}`)}</Typography>
            {day.hours.map((singleInput, index) => (
              <OpeningHoursInput
                key={index}
                index={index}
                day={day}
                singleInput={singleInput}
                onChange={handleInputChange}
              />
            ))}
          </Box>
        )
      })}
    </>
  )
}

export default OpeningHoursDays
